import { X } from 'lucide-react';
import { useWhatsAppWidget } from '../hooks/useWhatsAppWidget';
import { WhatsAppIcon } from './whatsapp/WhatsAppIcon';
import { WhatsAppPanel } from './whatsapp/WhatsAppPanel';
import { WhatsAppGreeting } from './whatsapp/WhatsAppGreeting';

const WhatsAppButton = () => {
  const { open, showTip, close, toggle } = useWhatsAppWidget();
  return (
    <>
      {open && <WhatsAppPanel close={close} />}
      {showTip && <WhatsAppGreeting />}
      <button data-testid="whatsapp-toggle-button" type="button" aria-expanded={open} aria-controls="whatsapp-panel" onClick={toggle} className="fixed bottom-5 left-4 sm:bottom-6 sm:left-6 z-[91] w-14 h-14 sm:w-[60px] sm:h-[60px] rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.65)] flex items-center justify-center transition-all duration-300 hover:scale-110 group" aria-label="WhatsApp ile iletisim">
        {!open && <><span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" /><span className="absolute inset-0 rounded-full bg-[#25D366]/30 animate-ping [animation-delay:0.6s]" /></>}
        <span className="relative">{open ? <X size={24} strokeWidth={2.4} /> : <WhatsAppIcon className="w-7 h-7 fill-current" />}</span>
      </button>
    </>
  );
};

export default WhatsAppButton;